import { HttpClient } from "@angular/common/http";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from "@angular/core";
import { Constants } from "@constants";
import { ImagenURLDTO, ItemPreguntaDTO } from "@DTOS";
import { ItemPreguntaModelDTO, PreguntaModelDTO } from "@Models";
import { ICommand, CommandAsync } from "@nahuelmorata/ngx-command";
import { ModalService, NotificacionServiceEmisor } from "@shared/services";
import { firstValueFrom } from "rxjs";
import { EditorCondicionesComponent } from "src/app/layout/encuestas/encuestas-detalle/editor-condiciones/editor-condiciones.component";
import { EncuestasService } from "src/app/layout/encuestas/encuestas.service";
import { TiposPreguntasService } from "../../../tipos-preguntas.service";

@Component({
    selector: "app-item-pregunta-seleccion-imagen",
    templateUrl: "./item-pregunta-seleccion-imagen.component.html",
    styleUrls: ["./item-pregunta-seleccion-imagen.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ItemPreguntaSeleccionImagenComponent implements OnChanges {
    @Input() protected item: ItemPreguntaModelDTO = new ItemPreguntaModelDTO(new ItemPreguntaDTO());
    @Input() protected accesoPublico = true;
    @Input() protected color: string;
    @Input() protected pregunta: PreguntaModelDTO;
    @Output() protected borrarItem = new EventEmitter<void>();
    @Output() protected abrirAcciones = new EventEmitter<void>();

    protected readonly s3URL = Constants.S3URL;
    protected tieneImagen = false;

    protected subirImagenItemCmd: ICommand = new CommandAsync(() => this.subirImagenItem());

    constructor(private modalService: ModalService, private encuestasService: EncuestasService,
        private tiposPreguntasService: TiposPreguntasService, private httpClient: HttpClient,
        private changeDetectorRef: ChangeDetectorRef, private notificacionService: NotificacionServiceEmisor) {}

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.item != null && changes.item.currentValue != null) {
            this.verificarImagen();
        }
    }

    protected abrirEditorCondiciones() {
        if (this.accesoPublico) {
            return;
        }
        const modalRef = this.modalService.open(EditorCondicionesComponent, {
            centered: true,
            windowClass: "modal-condiciones"
        });
        const instancia = modalRef.componentInstance;
        instancia.item = this.item;
        instancia.encuesta = this.tiposPreguntasService.encuesta;
    }

    private async subirImagenItem(): Promise<void> {
        const url = await this.modalService.openModalInput("Ingrese la nueva URL", "", { centered: true });
        if (url == null) {
            return;
        }
        if (!url.endsWith(".jpg") && !url.endsWith(".jpeg")) {
            this.notificacionService.notificarError("La URL debe ser una imagen con el formato jpg o jpeg.");
            return;
        }
        const imagenURLDTO = new ImagenURLDTO();
        imagenURLDTO.imagenURl = url;
        await firstValueFrom(
            this.encuestasService.subirImagenItem(
                this.tiposPreguntasService.encuesta, this.pregunta.Entidad, this.item.Entidad, imagenURLDTO
            )
        );
    }

    private async verificarImagen() {
        try {
            await firstValueFrom(
                this.httpClient.get(`${Constants.S3URL}/images/items/${this.item.Id}.jpg`, { responseType: "arraybuffer" })
            );
            this.tieneImagen = true;
            this.changeDetectorRef.detectChanges();
        } catch {
        }
    }
}
